module.exports = __webpack_public_path__ + "img/40_69_012_570.228e1baf.jpg";